import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { twMerge } from '@belong/common';
import { ButtonBase } from '../ButtonBase/ButtonBase.js';

function getSizeClassName(responsiveSize) {
  if (typeof responsiveSize === 'string') {
    return breakpointSizeMap['_'][responsiveSize];
  }
  const entries = Object.entries(responsiveSize);
  return entries.reduce((acc, value) => {
    const breakpoint = value[0];
    const size = value[1];
    return `${acc} ${breakpointSizeMap[breakpoint][size]}`;
  }, '');
}
const Button = /*#__PURE__*/React.forwardRef(function Button({
  variant = 'solid',
  buttonType = 'primary',
  size = {
    _: 'fluid',
    lg: 'default'
  },
  type = 'button',
  fixed = false,
  className,
  uppercase,
  ...rest
}, ref) {
  let _size = size;
  if (variant === 'text') {
    _size = 'auto';
  }
  let _uppercase = uppercase;
  if (typeof uppercase === 'undefined' && variant === 'text') {
    _uppercase = true;
  }
  return jsx(ButtonBase, {
    className: twMerge('body font-semibold flex items-center justify-center', _uppercase && 'uppercase', !fixed && 'rounded', getSizeClassName(_size), transition, defaultStylesMap[variant]?.[buttonType], hoverMap[variant]?.[buttonType], disabledMap[variant], className),
    type: type,
    ref: ref,
    ...rest
  });
});
const defaultStylesMap = {
  solid: {
    primary: 'h-button max-h-full bg-green text-white shadow-button',
    danger: 'h-button max-h-full bg-red text-white'
  },
  text: {
    primary: 'bg-transparent text-navy',
    secondary: 'bg-transparent text-green',
    danger: 'bg-transparent text-red',
    light: 'bg-transparent text-white'
  },
  outline: {
    primary: 'h-button max-h-full bg-white text-navy border border-solid border-navy',
    secondary: 'h-button max-h-full bg-transparent text-green border-2 border-solid border-green'
  }
};
const breakpointSizeMap = {
  _: {
    default: 'w-button-default',
    small: 'w-button-small',
    large: 'w-button-large',
    fluid: 'w-button-fluid',
    auto: 'w-auto inline-block'
  },
  sm: {
    default: 'sm:w-button-default',
    small: 'sm:w-button-small',
    large: 'sm:w-button-large',
    fluid: 'sm:w-button-fluid',
    auto: 'sm:w-auto sm:inline-block'
  },
  md: {
    default: 'md:w-button-default',
    small: 'md:w-button-small',
    large: 'md:w-button-large',
    fluid: 'md:w-button-fluid',
    auto: 'md:w-auto md:inline-block'
  },
  lg: {
    default: 'lg:w-button-default',
    small: 'lg:w-button-small',
    large: 'lg:w-button-large',
    fluid: 'lg:w-button-fluid',
    auto: 'lg:w-auto lg:inline-block'
  },
  xl: {
    default: 'xl:w-button-default',
    small: 'xl:w-button-small',
    large: 'xl:w-button-large',
    fluid: 'xl:w-button-fluid',
    auto: 'xl:w-auto xl:inline-block'
  }
};
/* focus:outline-none; ASK RANDY WHY OUTLINE NONE FOR focus? */
const hoverMap = {
  solid: {
    primary: 'hover:bg-light-green active:bg-light-green focus:bg-light-green',
    danger: 'hover:bg-dark-red active:bg-dark-red focus:bg-dark-red'
  },
  text: {
    primary: 'hover:text-dark-navy active:text-dark-navy focus:text-dark-navy',
    secondary: 'hover:text-dark-green active:text-dark-green focus:text-dark-green',
    danger: 'hover:text-dark-red active:text-dark-red focus:text-dark-red',
    light: 'hover:text-green active:text-green focus:text-green'
  },
  outline: {
    primary: 'hover:text-dark-navy hover:border-2 hover:border-dark-navy active:text-dark-navy active:border-2 active:border-dark-navy focus:text-dark-navy focus:border-2 focus:border-dark-navy',
    secondary: 'hover:text-dark-green hover:border-2 hover:border-dark-green active:text-dark-green active:border-2 active:border-dark-green focus:text-dark-green focus:border-2 focus:border-dark-green'
  }
};
const disabledMap = {
  solid: 'disabled:bg-gray disabled:shadow-none',
  outline: 'disabled:bg-light-gray disabled:shadow-none disabled:border-gray disabled:text-gray',
  text: 'disabled:text-gray'
};
const transition = 'transition-colors duration-hover';

export { Button, breakpointSizeMap, defaultStylesMap, disabledMap, getSizeClassName, hoverMap, transition };
